module.exports = __webpack_public_path__ + "img/cab_270.b93ceaea.jpg";